import React from 'react'
import {
	AppDate,
	AppInput,
	AppSelect,
	AppSearchInput,
	AppSearchItem,
	AppRadio,
	AppSwitch,
} from 'components/AppFormItem'

export default class extends React.Component<IPage> {
	state = {
		params: {
			orderBy: 'create_time desc',
		},
	}

	render() {
		return (
			<div>
				<div style={{ width: 400, padding: 20 }}>
					<AppDate />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppInput />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppSelect />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppSearchInput />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppSearchItem />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppRadio />
				</div>
				<div style={{ width: 400, padding: 20 }}>
					<AppSwitch checkedLabel="启用" unCheckedLabel="禁用" />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/System/AuditPage.tsx